import React from 'react';
import './Modal.css';

const OutputModal = ({ output, onClose }) => {
  const handleClose = () => {
    onClose();
  };

  const handleDownload = () => {
    if (output?.path) {
      // TODO: Implement actual download functionality
      console.log('Downloading:', output.path);
      alert('Download functionality coming soon!');
    }
  };

  const renderOutput = () => {
    if (!output) return null;

    switch (output.type) {
      case 'script':
        return (
          <div className="output-content">
            <h4>Generated Script</h4>
            <div className="script-output">
              <pre>{output.content}</pre>
            </div>
            <div className="output-metadata">
              <p><strong>Prompt:</strong> {output.metadata?.prompt}</p>
              <p><strong>Genre:</strong> {output.metadata?.genre}</p>
              <p><strong>Duration:</strong> {output.metadata?.duration} seconds</p>
              <p><strong>Generated:</strong> {new Date(output.metadata?.generated_at).toLocaleString()}</p>
            </div>
          </div>
        );

      case 'narration':
        return (
          <div className="output-content">
            <h4>Generated Narration</h4>
            <div className="narration-output">
              <p>{output.content}</p>
            </div>
            <div className="output-metadata">
              <p><strong>Style:</strong> {output.metadata?.style}</p>
              <p><strong>Generated:</strong> {new Date(output.metadata?.generated_at).toLocaleString()}</p>
            </div>
          </div>
        );

      case 'video':
        return (
          <div className="output-content">
            <h4>Generated Video</h4>
            <div className="video-output">
              <video controls width="100%">
                <source src={output.path} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
            <div className="output-metadata">
              <p><strong>Style:</strong> {output.metadata?.style}</p>
              <p><strong>Duration:</strong> {output.metadata?.duration} seconds</p>
              <p><strong>Generated:</strong> {new Date(output.metadata?.generated_at).toLocaleString()}</p>
            </div>
          </div>
        );

      case 'audio':
        return (
          <div className="output-content">
            <h4>Generated Audio</h4>
            <div className="audio-output">
              <audio controls>
                <source src={output.path} type="audio/mpeg" />
                Your browser does not support the audio tag.
              </audio>
            </div>
            <div className="output-metadata">
              <p><strong>Voice:</strong> {output.metadata?.voice}</p>
              <p><strong>Generated:</strong> {new Date(output.metadata?.generated_at).toLocaleString()}</p>
            </div>
          </div>
        );

      case 'movie':
        return (
          <div className="output-content">
            <h4>Final Movie</h4>
            <div className="movie-output">
              <video controls width="100%">
                <source src={output.path} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
            <div className="output-metadata">
              <p><strong>Format:</strong> {output.metadata?.format}</p>
              <p><strong>Quality:</strong> {output.metadata?.quality}</p>
              <p><strong>Generated:</strong> {new Date(output.metadata?.generated_at).toLocaleString()}</p>
            </div>
          </div>
        );

      case 'text':
        return (
          <div className="output-content">
            <h4>Text Output</h4>
            <div className="text-output">
              <p>{output.content}</p>
            </div>
          </div>
        );

      default:
        return (
          <div className="output-content">
            <h4>Output</h4>
            <div className="default-output">
              <p>Output type: {output.type}</p>
              <p>Content: {output.content}</p>
            </div>
          </div>
        );
    }
  };

  if (!output) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content output-modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Node Output</h3>
          <button className="close-btn" onClick={handleClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>
        
        <div className="modal-body">
          {renderOutput()}
        </div>
        
        <div className="modal-footer">
          <button className="btn" onClick={handleClose}>
            Close
          </button>
          {(output?.path && (output?.type === 'video' || output?.type === 'audio' || output?.type === 'movie')) && (
            <button className="btn btn-primary" onClick={handleDownload}>
              <i className="fas fa-download"></i> Download
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default OutputModal;
